import { Injectable } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { Autocolor } from '../models/autocolor';
import { FormulaColorView } from '../models/formulacolorview';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { AutocolorService, FormulaService } from '../services';
import { NotificacionService } from '../services/notificacion.service';
import { Sistema } from '../models/sistema';

@Injectable({
  providedIn: 'root'
})
export class AutocolorStore {
  private readonly _formulas = new BehaviorSubject<FormulaColorView[]>([]);
  private readonly _colores = new BehaviorSubject<Autocolor[]>([]);

  readonly formulas$ = this._formulas.asObservable();
  readonly colores$ = this._colores.asObservable();

  paramsFormula: ParamsPlantilla;
  paramsColor: ParamsPlantilla;

  sistema: Sistema | null = null;

  constructor(
    private colorService: AutocolorService,
    private formulaService: FormulaService,
    private messageService: MessageService,
    private notificacionService: NotificacionService,
    private confirmationService: ConfirmationService,
  ) { }

  get colores(): Autocolor[] {
    return this._colores.getValue();
  }

  set colores(val: Autocolor[]) {
    this._colores.next(val);
  }

  set formulas(val: FormulaColorView[]) {
    this._formulas.next(val);
  }
  get formulas(): FormulaColorView[] {
    return this._formulas.getValue();
  }


  buscarFormulas(params: ParamsPlantilla) {
    this.paramsFormula = params;
    this.formulaService.buscarFormulasColor(params)
      .pipe(first())
      .subscribe(colors => {
        this._formulas.next(colors);

        if (this.formulas.length == 0) {
          this.confirmationService.confirm({
            message: '¿Quiere notificar que no existen formulas con los datos ingresados?',
            header: 'No se encontraron resultados',
            icon: 'pi pi-question',
            accept: () => {
              this.notificacionService.addNotificacion(this.paramsFormula).subscribe();
              this.messageService.add({ severity: 'success', summary: 'Aviso', detail: 'Notificacion realizada' });
            },
            reject: () => {

            }
          });

          // this.messageService.add({ severity: 'info', summary: 'Aviso', detail: 'No se encontraron resultados' });
        }
      });
  }

  buscarColores(color: ParamsPlantilla) {
    this.colorService.buscarColores(color)
      .pipe(first())
      .subscribe(colors => {
        this._colores.next(colors);
        if (this.colores.length == 0) {
          this.messageService.add({ severity: 'info', summary: 'Aviso', detail: 'No se encontraron resultados' });
        }
      });
  }

  limpiarStore() {
    this.colores = [];
    this.formulas = [];
    this.paramsColor = {};
    this.paramsFormula = {};
    this.sistema = null;
  }

}
